import { FieldPassword } from 'reactApp/components/Forms/FieldPassword/FieldPassword';
import { FieldPlanParams } from 'reactApp/components/Forms/FieldPlanParams/FieldPlanParams';
import { FieldSelect } from 'reactApp/components/Forms/FieldSelect';
import { FieldTextArea } from 'reactApp/components/Forms/FieldTextArea';
import { NetworkSelect } from 'reactApp/components/Forms/NetworkSelect';
import { FieldColor } from 'reactComponents/Forms/FieldColor';
import { FieldCommonErrorMessages } from 'reactComponents/Forms/FieldCommonErrorMessages/FieldCommonErrorMessages';
import { FieldFile } from 'reactComponents/Forms/FieldFile/FieldFile';
import { FieldSearch } from 'reactComponents/Forms/FieldSearch/FieldSearch';
import { FieldVolumeType } from 'reactComponents/Forms/FieldVolumeType';

import { AvailabilityZoneSelect } from './AvailabilityZoneSelect';
import { FieldCaptcha } from './FieldCaptcha/FieldCaptcha';
import { FieldCheckbox } from './FieldCheckbox';
import { FieldCheckboxGroup } from './FieldCheckboxGroup';
import { FieldDependentValue } from './FieldDependentValue';
import { FieldDiskType } from './FieldDiskType';
import { FieldDiskTypeByAvailabilityZone } from './FieldDiskTypeByAvailabilityZone/FieldDiskTypeByAvailabilityZone';
import { FieldInput } from './FieldInput';
import { FieldMultipleSelect } from './FieldMultipleSelect';
import { FieldRadioGroup } from './FieldRadioGroup';
import { FieldsAvailabilityZoneByFlavor } from './FieldsAvailabilityZoneAndFlavor/FieldsAvailabilityZoneByFlavor';
import { FieldSubnet } from './FieldSubnet/FieldSubnet';
import { FieldTrigger } from './FieldTrigger/FieldTrigger';
import { FlavorSelect } from './FlavorSelect';
import { Form } from './Form';
import { FormikContext } from './FormikContext';
import { FormWrapper } from './FormWrapper';
import { KeySelect } from './KeySelect';
import { SecurityGroupSelect } from './SecurityGroupSelect';
import { Validation } from './Validation/Validation';

export const Forms = {
    FormikContext,
    FieldSearch,
    FormWrapper,
    Form,
    FieldInput,
    FieldTextArea,
    FieldDependentValue,
    FieldPassword,
    FieldTrigger,
    FieldFile,
    FieldSelect,
    FieldCheckbox,
    FlavorSelect,
    FieldMultipleSelect,
    AvailabilityZoneSelect,
    FieldsAvailabilityZoneByFlavor,
    FieldDiskTypeByAvailabilityZone,
    KeySelect,
    NetworkSelect,
    SecurityGroupSelect,
    FieldRadioGroup,
    FieldDiskType,
    FieldVolumeType,
    FieldSubnet,
    FieldCaptcha,
    Validation,
    FieldCommonErrorMessages,
    FieldPlanParams,
    FieldColor,
    FieldCheckboxGroup,
};
